import { fromJS } from 'immutable'
import React from 'react'
import Button from '../../../common/button'

/**
 * @param table
 * @param send
 * @param onDone
 */
class Chat extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            query: "",
            selectedIdx: 0
        }

        const onArrowKeyUsed = () => {
            if (this._chatRef) {
                const child = this._chatRef.children[this.state.selectedIdx]
                const pos = child ? child.offsetTop - child.clientHeight : 0
                this._chatRef.scrollTo(0, pos)
            }
        }

        this._keyDownListener = evt => {
            const key = evt.key
            if (key && key.length == 1 && this.state.query.length < 50) {
                this.updateQuery(this.state.query + key)
            } else if (key === "Backspace") {
                if (this.state.query.length) {
                    this.updateQuery("")
                } else if (this.props.onDone) {
                    this.props.onDone()
                }
                evt.preventDefault()
                evt.stopPropagation()
            } else if (key === "Enter") {
                const msgToSend = this.getDisplayedMessages().get(this.state.selectedIdx)
                if (msgToSend) {
                    this.handleSendChatMessage(msgToSend.get("message"))
                }
            } else if (key === "ArrowUp") {
                evt.preventDefault()
                evt.stopPropagation()
                this.setState({ selectedIdx: Math.max(0, this.state.selectedIdx - 1) }, onArrowKeyUsed)
            } else if (key === "ArrowDown") {
                evt.preventDefault()
                evt.stopPropagation()
                this.setState({ selectedIdx: Math.min(this.getDisplayedMessages().size - 1, this.state.selectedIdx + 1) }, onArrowKeyUsed)
            }
        }
        window._isChatOpen = true
        window.addEventListener("keydown", this._keyDownListener)
    }

    componentWillUnmount()
    {
        window._isChatOpen = false
        window.removeEventListener("keydown", this._keyDownListener)
    }

    handleSendChatMessage(message)
    {
        this.props.send({
            type: "CHAT",
            message: message
        })
        if (this.props.onDone)
        {
            this.props.onDone()
        }
    }

    getDisplayedMessages(query = this.state.query)
    {
        const clean = txt => txt.toLowerCase().replace(/[-_\.,\?!\s'=><]/g, "")

        return this.props.table.get("chatMessages")
            .filter(msg => {
                if (query) {
                    const messageText = this.getMessageText(msg)
                    const keywordsMatch = msg.get("keywords").some(kw => kw.includes(clean(query)))
                    return keywordsMatch || (msg.get("type") == "TEXT" && clean(messageText).includes(clean(query)))
                }
                return true
            })
            .sort((a, b) => a.get("type").localeCompare(b.get("type")))
    }

    updateQuery(q)
    {
        this.setState({ query: q, selectedIdx: 0 })
    }

    getMessageText(msg)
    {
        return Messages.apply(null, [ msg.get("message") ].concat(msg.get("messageArgs") ? msg.get("messageArgs").toJS() : []))
    }

    render()
    {
        const t = this.props.table

        let messagesViews = this.getDisplayedMessages()
            .map((msg, idx) => {

                const selectedBox = this.state.selectedIdx === idx ? (
                    <div className="selected-box">{ Messages("table.chat.send") }</div>
                ) : null

                let image = msg.get("type") === "IMAGE" ? (
                    <img src={ getImageLink(msg.get("message")) }></img>
                ) : null

                let text = msg.get("type") === "TEXT" ? (
                    this.getMessageText(msg)
                ) : null

                return (
                    <div
                        className={ "chatbox " + (selectedBox ? " selected" : "") + (image ? " image " : "") }
                        key={ msg.get("message") }
                        onClick={ () => this.handleSendChatMessage(msg.get("message")) }>
                        { image }
                        { text }
                        { selectedBox }
                    </div>
                )
            })

        if (!messagesViews.size) {
            messagesViews = [
                <div key="--none" className="query-no-results">{ Messages("table.chat.query.no-results") }</div>
            ]
        }

        return (
            <div className="chat" ref={ ref => this._chatRef = this._chatRef || ref }>
                { messagesViews }
                <div className={ "query-box " + (this.state.query ? "has-query" : "") }>
                    <div className="query">
                        { Messages(this.state.query ? "table.chat.query" : "table.chat.info", this.state.query) }
                    </div>
                </div>
            </div>
        )
    }

}

export function getImageLink(imgName)
{
    return "/assets/images/chat/" + imgName + ".png"
}

export default Chat
export { Chat }